module.exports = __webpack_public_path__ + "img/shop.377bb5d2.png";